module.exports = __webpack_public_path__ + "img/microplastics-process-7-mobile.1533c9fc.png";